"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePeerInfo = void 0;
const helpers_1 = require("../../helpers");
const constants_1 = require("../../payloads/constants");
const validatePeerInfo = peerInfo => {
  const {
    signal,
    address,
    meta
  } = peerInfo;
  if (!signal) {
    throw new Error('Invalid signal data received');
  }
  if (!(0, helpers_1.isValidPushCAIP)(address)) {
    throw new Error('Invalid address received');
  }
  if (meta.rules.access.type === constants_1.VIDEO_NOTIFICATION_ACCESS_TYPE.PUSH_CHAT && !meta.rules.access.data.chatId) {
    throw new Error('ChatId not found in meta.rules');
  }
};
exports.validatePeerInfo = validatePeerInfo;
//# sourceMappingURL=validatePeerInfo.js.map